import PropTypes from "prop-types"
import { createContext, useEffect, useState } from "react"
import { useQuery } from "react-query"
import { listCategories } from "~/actions/categories"

const CategoriesContext = createContext()
export default CategoriesContext

export const CategoriesContainer = ({ children }) => {
  const { data: categories, refetch: refetchCategories } = useQuery(
    "categories",
    () => listCategories(),
  )

  const [categoriesLoading, setCategoriesLoading] = useState(true)

  useEffect(() => {
    if (categories !== undefined) {
      setCategoriesLoading(false)
    } else {
      setCategoriesLoading(true)
    }
  }, [categories])
  return (
    <CategoriesContext.Provider
      value={{
        categories,
        refetchCategories,
        categoriesLoading,
        // setAuthData,
      }}
    >
      {children}
    </CategoriesContext.Provider>
  )
}

CategoriesContainer.propTypes = {
  children: PropTypes.node,
  category: PropTypes.object,
}
